export function requestQuote()
{
    return axios.post(route('api.manage.companies.multi-posting.request'), {
            type: 'quote',
    })
        .then(({data}) => data);
}

export function requestContact()
{
    return axios.post(route('api.manage.companies.multi-posting.request'), {
            type: 'contact',
    })
        .then(({data}) => data);
}

export function contracts(search)
{
    return axios.get(route('api.manage.companies.multi-posting.contracts', {search}))
        .then(({data}) => data);
}

export function createContract(data)
{
    return axios.post(route('api.manage.companies.multi-posting.contracts'), data)
        .then(({data}) => data);
}